// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".details-section[data-v-523b94bc]{padding-top:50px}.wrap-text[data-v-523b94bc]{white-space:normal}.date-column[data-v-523b94bc]{min-width:120px}", ""]);
// Exports
module.exports = exports;
